/**
 * AdminHelpLoadError - erro de carregamento do painel de suporte, com o texto da API e "Tentar de novo".
 */

import React from 'react';

interface AdminHelpLoadErrorProps {
  message: string;
  onRetry: () => void;
}

const AdminHelpLoadError: React.FC<AdminHelpLoadErrorProps> = ({ message, onRetry }) => (
  <div
    role="alert"
    className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-destructive/40 bg-destructive/5 p-4 text-sm"
  >
    <span className="min-w-0 break-words text-destructive">{message}</span>
    <button
      type="button"
      onClick={onRetry}
      className="shrink-0 rounded-md border border-border bg-background px-3 py-1.5 text-sm text-foreground transition-colors hover:bg-muted"
    >
      Tentar de novo
    </button>
  </div>
);

export default AdminHelpLoadError;
